import * as React from "react"
export const Svg_056 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={58}
    height={58}
    fill="none"
  >
    <path fill="url(#a)" d="M43.84 34.7h3.398V38.1H43.84V34.7Z" />
    <path fill="url(#b)" d="M43.84 8.501h3.398v22.8H43.84v-22.8Z" />
    <path
      fill="url(#c)"
      d="M53.374 31.302A4.632 4.632 0 0 0 58 26.675V8.501h-7.363v22.8h2.737Z"
    />
    <path fill="url(#d)" d="M10.762 34.7h3.398V38.1h-3.398V34.7Z" />
    <path fill="url(#e)" d="M10.762 8.501h3.398v22.8h-3.398v-22.8Z" />
    <path
      fill="url(#f)"
      d="M50.637 34.7v6.797H40.44V34.7H17.56v6.797H7.363V34.7H4.626A7.98 7.98 0 0 1 0 33.23v16.27h58v-16.27a7.981 7.981 0 0 1-4.626 1.471h-2.737Z"
    />
    <path
      fill="url(#g)"
      d="M4.626 31.302h2.737V8.5H0v18.174a4.632 4.632 0 0 0 4.626 4.627Z"
    />
    <path
      fill="url(#h)"
      d="M40.441 31.302V8.5H17.56v22.8H40.44Zm-4.724-11.4V23.3H22.283V19.9h13.434Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={44.626}
        x2={46.24}
        y1={35.21}
        y2={37.822}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={44.626}
        x2={50.147}
        y1={11.921}
        y2={13.253}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={52.34}
        x2={62.282}
        y1={11.921}
        y2={17.118}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={11.548}
        x2={13.162}
        y1={35.21}
        y2={37.822}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="e"
        x1={11.548}
        x2={17.069}
        y1={11.921}
        y2={13.253}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="f"
        x1={13.412}
        x2={16.321}
        y1={35.669}
        y2={52.448}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="g"
        x1={1.703}
        x2={11.645}
        y1={11.921}
        y2={17.118}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="h"
        x1={22.85}
        x2={33.663}
        y1={11.921}
        y2={29.484}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)